<template>
  <div class="container">

  <div class="input-group mb-3 mt-4">
    <input v-model="ruta" type="text" class="form-control" placeholder="Ruta en servidor" aria-label="Recipient's username" aria-describedby="basic-addon2">
    <div class="input-group-append">
      <button @click="getJson()" class="btn btn-success" type="button">Obtener json</button>
    </div>
    <!-- <button @click="copy">Copy</button> -->
  </div>

    <pre class="text-primary">{{data }}</pre>
  </div>
</template>
<script>
import axios from "axios";
export default {
    name: 'correccion',
    data() {
        return {
          ruta: "",
          data: []
        };
    },
    methods: {
      async getJson() {
        try {
            const res = await axios.get(this.ruta);
            this.data = res.data;
            this.sortJson()
        } catch (error) {
            console.error(error.message);
        }
      },
      sortJson(){
        let orden = this.data.reverse();

        for(let i=0; i<this.data.length; i++){
          console.log(i);
          orden[i].id = i+1;
        }

        console.log(orden);
        this.data = orden;

      },
      // copy() {
      // // this.$refs.myinput.focus();
      // this.data.execCommand('copy');
    // }
    }
}
</script>
